import React from 'react'
import ArrowButton from 'components/ui/buttons/ArrowButton'
import { css, StyleSheet } from 'aphrodite'
import { useTranslation } from 'react-i18next'
import { IApplicationState } from 'components/store/types'
import { getCurrentRegion, getUrgencyLink } from 'components/core/state/selectors'
import { connect, ConnectedProps } from 'react-redux'
import constants from 'utils/constants'

const mapState = (state: IApplicationState) => ({
  currentRegion: getCurrentRegion(state),
  emergencyLink: getUrgencyLink(state),
})
const connector = connect(mapState)

const EmergencyButton = ({ currentRegion, emergencyLink }: ConnectedProps<typeof connector>) => {
  const { t } = useTranslation()
  const handleClick = () => window.open(`${emergencyLink}?location=${currentRegion}`, '_blank')
  return (
    <ArrowButton buttonStyle={css(styles.button)} onClick={handleClick} text={t('emergency')} />
  )
}
const styles = StyleSheet.create({
  button: {
    background: constants.colors.orange,
  },
})
export default connector(EmergencyButton)
